import { HTTP } from './http_service';

export const fetchUnits = function(query = undefined) {
  query = query || '';
  return HTTP.post('/online/poster-filler/units?field=&order=&query=' + query).then((units) => {
    return units.data;
  });
};

export const fetchDepartments = function(query = undefined) {
  query = query || '';

  return HTTP.post('/online/poster-filler/departments?field=&order=&query=' + query).then((departments) => {
    return departments.data;
  });
};

export const fetchProducts = function(query = undefined) {
  query = query || '';

  return HTTP.post(encodeURI('/online/poster-filler/products?field=&order=&query=' + query)).then((products) => {
    return products.data;
  });
};

export const fetchProduct = function(code, campaignId) {
  let url = `/online/poster-filler/product/?product_code=${code}&campaign_id=${campaignId}`;
  return HTTP.post(url).then((product) => {
    return product.data;
  });
};

export default {
  fetchUnits,
  fetchProduct,
  fetchProducts,
  fetchDepartments,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/services/product_service.js